(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .service('karcherOperatingTimeDaysMapper', karcherOperatingTimeDaysMapper);

  /** @ngInject */
  function karcherOperatingTimeDaysMapper(helperService) {
    this.getDays = function (daysPoint) {
      var tempArray = [], tempObj = {};

      for (var i = 0; i < daysPoint.length; i++) {
        for (var j = 0; j < daysPoint[i].actuators.length; j++) {
          if (
            daysPoint[i].name === 'Mon' ||
            daysPoint[i].name === 'IlluminationMon' ||
            daysPoint[i].name === 'VacuumsMon'
          ) {
            tempObj.day = 'MON';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 1;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Tue' ||
            daysPoint[i].name === 'IlluminationTue' ||
            daysPoint[i].name === 'VacuumsTue'
          ) {
            tempObj.day = 'TUE';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 2;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Wed' ||
            daysPoint[i].name === 'IlluminationWed' ||
            daysPoint[i].name === 'VacuumsWed'
          ) {
            tempObj.day = 'WED';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 3;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Thu' ||
            daysPoint[i].name === 'IlluminationThu' ||
            daysPoint[i].name === 'VacuumsThu'
          ) {
            tempObj.day = 'THU';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 4;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Fri' ||
            daysPoint[i].name === 'IlluminationFri' ||
            daysPoint[i].name === 'VacuumsFri'
          ) {
            tempObj.day = 'FRI';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 5;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Sat' ||
            daysPoint[i].name === 'IlluminationSat' ||
            daysPoint[i].name === 'VacuumsSat'
          ) {
            tempObj.day = 'SAT';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 6;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Sun' ||
            daysPoint[i].name === 'IlluminationSun' ||
            daysPoint[i].name === 'VacuumsSun'
          ) {
            tempObj.day = 'SUN';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 7;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Hol' ||
            daysPoint[i].name === 'IlluminationHol' ||
            daysPoint[i].name === 'VacuumsHol'
          ) {
            tempObj.day = 'HOLIDAY';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 8;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          }
          // Mapping actuators
          if (
            daysPoint[i].actuators[j].reference === 'START' ||
            daysPoint[i].actuators[j].reference === 'ILL_START' ||
            daysPoint[i].actuators[j].reference === 'VAC_START'
          ) {
            tempObj.from = daysPoint[i].actuators[j].value;
            tempObj.fromState = daysPoint[i].actuators[j].state;
            daysPoint[i].actuators[j].groupValue = 1;
          } else if (
            daysPoint[i].actuators[j].reference === 'STOP' ||
            daysPoint[i].actuators[j].reference === 'ILL_STOP' ||
            daysPoint[i].actuators[j].reference === 'VAC_STOP'
          ) {
            tempObj.to = daysPoint[i].actuators[j].value;
            tempObj.toState = daysPoint[i].actuators[j].state;
            daysPoint[i].actuators[j].groupValue = 2;
          } else if (
            daysPoint[i].actuators[j].reference === '24H' ||
            daysPoint[i].actuators[j].reference === 'ILL_24H' ||
            daysPoint[i].actuators[j].reference === 'VAC_24H'
          ) {
            tempObj.allDay = daysPoint[i].actuators[j].value;
            tempObj.allDayState = daysPoint[i].actuators[j].state;
            daysPoint[i].actuators[j].groupValue = 3;
          }
        }
        // Check if tempObj is empty
        if (!helperService.checkIfObjectIsEmpty(tempObj)) {
          tempArray.push(tempObj);
          tempObj = {};
        }
      }
      return tempArray;
    };
  }
})();
